/* eslint-disable react/no-array-index-key */
import { FC } from 'react';

import { colors } from '~/constants/colors';

import { ButtonInfo, OurPillarsContainer } from './styles';
import { TypographH3, TypographSpan } from '../typograph';
import { RoutesEnum } from "~/enums/routes";
import Link from "next/link";

interface IOurPillarsButton {
  readonly color: string;
  readonly text: string;
  readonly textColor: string;
  readonly href: string;
}

export const OurPillars: FC = () => {
  const buttons: IOurPillarsButton[] = [
    {
      color: colors.blue,
      textColor: colors.text_white,
      text: "1. digital assessment",
      href: RoutesEnum.digital_assessment,
    },
    {
      color: colors.purple,
      textColor: colors.text_white,
      text: "2. digital blueprint",
      href: RoutesEnum.digital_blueprint,
    },
    {
      color: colors.light_green,
      textColor: colors.black,
      text: "3. performance racking",
      href: RoutesEnum.performance_racking,
    },
    {
      color: colors.green,
      textColor: colors.black,
      text: "4. evolution lifecycle",
      href: RoutesEnum.evolution_lifecycle,
    },
  ];

  return (
    <OurPillarsContainer>
      <TypographH3
        uppercase
        bold
        color={colors.green}
        size={12}
        lineHeight={16.8}
      >
        nossos pilares de atuação:
      </TypographH3>

      <ul>
        {buttons.map((btn, index) => (
          <Link href={btn.href}>
            <ButtonInfo key={String(index)} color={btn.color}>
              <TypographSpan
                uppercase
                bold
                size={12}
                lineHeight={16.8}
                color={btn.textColor}
              >
                {btn.text}
              </TypographSpan>
            </ButtonInfo>
          </Link>
        ))}
      </ul>
    </OurPillarsContainer>
  );
};
